import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    return {
      lastFetch: null,

      skippers: [
        {
          id: 's1',
          firstName: 'Fabrice',
          lastName: 'Amedeo',
          achievements: [
            'Vendée Arctique',
            'Transat Jacques Vabre',
            'Fastnet Race',
            'Route de Rhum'
          ],
          description:
            'Reporters at sea » could have well been Fabrice Amedeo’s website address during his first experience of the Vendée Globe in 2016-2017. At the time, he was navigating between two worlds  – half journalist, half .',
          age: 42
        },
        {
          id: 's2',
          firstName: 'Jérémie',
          lastName: 'Beyou',
          achievements: [
            'Vendée Arctique',
            'Transat Jacques Vabre',
            'Volvo Ocean'
          ],
          description:
            'Jérémie Beyou has never been afraid of being a forerunner. Without waiting to see what the competition would do, he chose to quickly start the construction of his new IMOCA, Charal.',
          age: 44
        },

        {
          id: 's3',
          firstName: 'Pip',
          lastName: 'Hare',
          achievements: [
            'Bermudes 1000 Race',
            'Rolex Fastnet Race',
            'Transat Jacques Vabre'
          ],
          description:
            'Pip Hare discovered solo sailing late, at 35 years old. Not because she hadn’t sailed before – with a 15-year career as a professional skipper behind her, the British skipper has since sailed tens of thousands of miles, including two Mini-Transats and one Transat Jacques Vabre',
          age: 46
        }
      ]
    };
  },
  mutations: mutations,
  actions: actions,
  getters: getters
};
